/* FAQ page rebuild — TICK-3448
   Topic buttons + subheading side menu (desktop) / collapsible groups (mobile).
   Question open/close animation is handled by the theme's cc-accordion (theme.js).
   All clicks are handled by a single delegated listener so theme editor section
   reloads (which re-run initState) can never stack duplicate handlers. */

(function () {
  'use strict';

  function getTopics() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-faq-topic]'));
  }

  function activateTopic(handle, updateHash) {
    var topics = getTopics();
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.faq-topic-nav__btn'));
    var found = topics.some(function (topic) {
      return topic.getAttribute('data-faq-topic') === handle;
    });
    if (!found) return;

    topics.forEach(function (topic) {
      var isActive = topic.getAttribute('data-faq-topic') === handle;
      topic.hidden = !isActive;
      topic.classList.add('faq-ready');
    });
    buttons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-handle') === handle;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
    if (updateHash && history.replaceState) {
      history.replaceState(null, '', '#' + handle);
    }
  }

  function activateGroup(topic, targetId) {
    var groups = topic.querySelectorAll('[data-faq-group]');
    Array.prototype.forEach.call(groups, function (group) {
      group.classList.toggle('is-active', group.id === targetId);
    });
    var links = topic.querySelectorAll('[data-faq-heading-link]');
    Array.prototype.forEach.call(links, function (link) {
      link.classList.toggle('is-active', link.getAttribute('data-target') === targetId);
    });
  }

  function toggleGroup(group, toggle) {
    var open = group.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function activateFromHash() {
    var topics = getTopics();
    if (!topics.length) return;
    var handle = location.hash.replace('#', '');
    var match = topics.some(function (topic) {
      return topic.getAttribute('data-faq-topic') === handle;
    });
    activateTopic(match ? handle : topics[0].getAttribute('data-faq-topic'), false);
  }

  // Idempotent: builds the topic nav and applies default states. Safe to call
  // repeatedly (initial load, theme editor section load/unload).
  function initState() {
    var header = document.querySelector('[data-faq-topic-nav]');
    var topics = getTopics();
    if (!header || !topics.length) return;

    var headerSection = header.closest('.faq-page-header');
    var accent = headerSection ? headerSection.style.getPropertyValue('--faq-accent') : '';
    var tint = headerSection ? headerSection.style.getPropertyValue('--faq-accent-tint') : '';

    header.innerHTML = '';
    topics.forEach(function (topic) {
      if (accent) topic.style.setProperty('--faq-accent', accent);
      if (tint) topic.style.setProperty('--faq-accent-tint', tint);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'faq-topic-nav__btn';
      btn.textContent = topic.getAttribute('data-faq-topic-title');
      btn.setAttribute('data-handle', topic.getAttribute('data-faq-topic'));
      header.appendChild(btn);

      // Defaults: first group active (desktop side menu) and open (mobile),
      // unless this topic already has state (preserves it across re-inits)
      var groups = topic.querySelectorAll('[data-faq-group]');
      if (groups.length && !topic.querySelector('[data-faq-group].is-active')) {
        activateGroup(topic, groups[0].id);
      }
      if (groups.length && !topic.querySelector('[data-faq-group].is-open')) {
        groups[0].classList.add('is-open');
        var firstToggle = groups[0].querySelector('[data-faq-group-toggle]');
        if (firstToggle) firstToggle.setAttribute('aria-expanded', 'true');
      }
    });

    activateFromHash();
  }

  // Single delegated click handler — bound exactly once per page load
  document.addEventListener('click', function (e) {
    var topicBtn = e.target.closest('.faq-topic-nav__btn');
    if (topicBtn) {
      activateTopic(topicBtn.getAttribute('data-handle'), true);
      return;
    }

    var headingLink = e.target.closest('[data-faq-heading-link]');
    if (headingLink) {
      var linkTopic = headingLink.closest('[data-faq-topic]');
      if (linkTopic) activateGroup(linkTopic, headingLink.getAttribute('data-target'));
      return;
    }

    var groupToggle = e.target.closest('[data-faq-group-toggle]');
    if (groupToggle) {
      var group = groupToggle.closest('[data-faq-group]');
      if (group) toggleGroup(group, groupToggle);
    }
  });

  window.addEventListener('hashchange', activateFromHash);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initState);
  } else {
    initState();
  }

  // Theme editor support: re-apply state when sections load/unload, and reveal
  // a topic section when the merchant selects it in the sidebar.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      // Re-init the theme accordion component for re-rendered FAQ sections
      if (window.jQuery && e.target.querySelector('.cc-accordion')) {
        window.jQuery(document).trigger('cc:component:load', ['accordion', e.target]);
      }
      initState();
    });
    document.addEventListener('shopify:section:unload', function () {
      setTimeout(initState, 0);
    });
    document.addEventListener('shopify:section:select', function (e) {
      var topic = e.target.querySelector('[data-faq-topic]');
      if (topic) activateTopic(topic.getAttribute('data-faq-topic'), false);
    });
  }
})();
